<template>
  <div class="agency-client-action-column" :data-test="`agency-client-actions-${rowIndex}`">
    <ClientActionsMenu
      :data-test="`agency-client-row-actions-${column.id}`"
      :global="tableGlobals"
      :can-manage-owners="column.viewerCanManageOwners"
      @view-page="openClientPage"
      @manage-owners="showOwnersModal = true"
    />

    <teleport :to="tableGlobals">
      <ClientOwnersModal
        v-if="showOwnersModal"
        :show="showOwnersModal"
        :client-relation-id="column.id"
        @update:show="showOwnersModal = $event"
      />
    </teleport>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ClientActionsMenu from '@/components/Clients/ClientActionsMenu.vue'
import ClientOwnersModal from '@/components/Owners/ClientOwnersModal.vue'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const tableGlobals = useTableGlobalsSelector()

const StaffingAgencyClientActionColumn = graphql(`
  fragment StaffingAgencyClientActionColumn on SupplierClient {
    id
    viewerCanManageOwners
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientActionColumn>
  rowIndex?: number
}>()

const emit = defineEmits<{ (e: 'open-page', supplierClientId: string): void }>()

const column = computed(() => useFragment(StaffingAgencyClientActionColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const showOwnersModal = ref(false)

// A menu option is no link, so modifier clicks get a new tab by hand.
function openClientPage(event: MouseEvent | undefined) {
  if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
    window.open(
      laravelNamedRoute(namedRoutes.frontend.clients.view, { companySupplier: column.value.id }),
      '_blank',
      'noopener',
    )
    return
  }

  emit('open-page', column.value.id)
}
</script>

<style scoped lang="scss">
.agency-client-action-column :deep(.wds-menu) {
  width: max-content;
}
</style>
